// src/components/translation-modules/TranslationModuleBase.js
import React from "react";

const TranslationModuleBase = ({
  title,
  children,
  onSave,
  onCancel,

  saveLabel = "Save",
  cancelLabel = "Cancel",
}) => {
  return (
    <div className="translation-module">
      <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 mb-4">
        <h2 className="text-xl font-bold mb-4">{title}</h2>
        <div className="translation-module-content mb-4">{children}</div>
        {(onSave || onCancel) && (
          <div className="flex justify-end space-x-2">
            {onCancel && (
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
              >
                {cancelLabel}
              </button>
            )}
            {onSave && (
              <button
                onClick={onSave}
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                {saveLabel}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TranslationModuleBase;
